var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    height: (_vm.pagesHeight + "px"),
    overflow: 'hidden'
  }),attrs:{"id":"Cool-9"}},[_c('div',{style:({
      width: '1920px',
      height: _vm.bodyHeight || '1080px',
      'transformOrigin':'left top',
      'transform':("scale(" + _vm.scalseNum + ")"),
      '-webkit-transform':("scale(" + _vm.scalseNum + ")"),
      '-moz-transform':("scale(" + _vm.scalseNum + ")"),
      '-o-transform':("scale(" + _vm.scalseNum + ")"),
      '-ms-transform':("scale(" + _vm.scalseNum + ")")
    })},[_vm._m(0),_c('Cool9First'),_c('Cool9Second')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h1',[_vm._v("酷开9.0数据看板")])])}]

export { render, staticRenderFns }